import View from './view';
export const ContentWithRightImageDesktopProfile = View;
